import styled from 'styled-components';

export const Page = styled.div`
    padding: 10px;
    padding-top: 20px;
    overflow-y: auto;

    @media (min-width: 760px){
        padding-top: 10px;
    }
`;